import styled from 'styled-components';

import { Button } from 'components/Button';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const SeasonSelect = styled.div`
  /* fits "ES27 · no closed budgets" */
  width: 22rem;
`;

// secondary to the red "Add new Budget" next to it, same height
const ExportButton = styled(Button)`
  height: 4rem;
`;

export { ExportButton, Wrapper, SeasonSelect };
